<template>

    <div class="container textAlignCenter">
        <StepGuide :stepCount="2"></StepGuide>

        <div class="body padding">

            <h1 class="padding teal textAlignCenter">Are you sure?</h1>

            <h3 class="padding">By clicking place order you are confirming <br>your artwork file is print ready, <br>agree
                to pay £{{printJob.grossTotalPrice}}*
                and <br> comply to Ravensworth payment terms.<br></h3>

            <div class="padding">

                <p>Delivery can be expected in 2-3 working days**</p>
                <p>If you have any queries, please contact</p>
                <div class="padding paddingTopSmall">
                    <p>Ravensworth Client Services:</p>
                    <p class="teal">0191 917 9331</p>
                    <p class="teal">client.support@ravensworth.co.uk</p>
                </div>

            </div>

            <el-button class="redButton ravensworthButtons" v-on:click="next()">Place Order</el-button>

            <div class="termsText paddingTopSmall padding textAlignCenter">
                *Delivery excluded.<br>
                **Please allow an additional 24 hours for saddle stitched jobs.<br>
                Invoices are issued at the beginning of the month. Payment terms are 30 days.<br>
                <a href="https://ravensworth.co.uk/terms-and-conditions/" target="_blank" class="black">Ravensworth Terms and Conditions</a>

            </div>
        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import Router from '../router';
    import StepGuide from '@/components/StepGuide.vue';
    import PrintJobSelections from '@/components/PrintJobSelections.vue';
    import {Loading} from 'element-ui';

    export default {
        name: "checkout",
        components: {
            StepGuide,
            PrintJobSelections
        },
        props: {
            searchParams: {},
            printJob: {}
        },
        data() {
            return {
                uploadPercentage: '',
            }
        },
        created() {


        },
        methods: {
            next() {

                let loadingInstance = Loading.service({
                    fullscreen: true
                });
                const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfupload/orders/finalise/` + this.printJob.id
                // const uri = '"https://media2.jupix.co.uk/v3/clients/5/properties/395696/MED_395696_240845.pdf"'

                // const uri = window.sessionStorage.getItem('_filename')

                console.log('before post')
                const headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                }

                console.log(headers)

                Axios.put(url, {}, headers)
                    .then(response => {
                        console.log(response)
                        this.printJob = response.data

                        if (this.printJob.orderFinalised === true) {
                            this.$nextTick(() => { // Loading should be closed asynchronously
                                loadingInstance.close();
                            });
                            Router.push({
                                name: 'confirmation',
                                params: {
                                    printJob: this.printJob
                                }
                            });
                        }
                    })


            }
        }
    };
</script>